import { h, Attributes } from 'preact'

interface Props {
  class?: string
  children: JSX.Element[]
  getItemProps?: (idx: number) => Attributes
}

export default function List (props: Props) {
  return (
    <ul class={`main-menu-list ${props.class || ''}`}>{props.children.map((item, idx) => {
      return <li class='main-menu-list__item' key={idx} {...props.getItemProps?.(idx)}>{item}</li>
    })}</ul>
  )
}
